import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddCustomerFocus.module.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";
import { useCertification } from "../../../../hooks/useCertification";

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="4.1"
          title="Procedure and/or Process for Advisory Services"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content: "Advice on the choice of examinations;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Communication of advisory services to its users;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Advice on clinical indications and limitations of examination procedures;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Advise on the frequency of examinations;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Provision of individual clinical advice;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Advice on interpretation of results;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Promotion of the effective utilization of laboratory services;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Consultation on scientific and logistic matters;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Advice on required sample types and volumes for testing.",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="4.2"
          title="Advice and Instruction by Qualified Personnel"
          questions={[
            {
              content:
                "Do laboratory personnel with appropriate professional qualifications provide patients and users with advice and/or training regarding required types of samples, choice of examinations, repeat frequency, and interpretation of results?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="4.3"
          title="Procedure and/or Process for Handling of Complaints and Feedback"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited, the following?",
              hideOptions: true,
            },
            {
              content: "Receipt and acknowledgment of complaints;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Investigation and action taken from complaints and feedback (where relevant);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Tracking and recording of complaints and feedback (where relevant);",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Defining timeframes for closure and feedback to the complainant;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Monitoring the effectiveness of corrective actions taken on complaints and feedback to complainant.",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="4.4"
          title="Receipt and Resolution of Complaints"
          questions={[
            {
              content:
                "Does the laboratory implement a process for the receipt and resolution of complaints? (Are there records of the original complaint and tracking and feedback?)",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="4.5"
          title="Requirements Regarding Patients"
          questions={[
            {
              content:
                "Has the laboratory established and implemented a process for treatment of patients’ well-being, samples, or remains, with due care and respect?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="4.6"
          title="Procedure and/or Process for Service Agreements (including POCT)"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Establishment of service agreements (requirements are specified);",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Review and approval of service agreements (capability and adequate resources);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Management of walk-in patients (where applicable);",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication of changes of the service agreement that affect examination results;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication to the requester of any work that has been referred;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Defining specified responsibilities and authorities for POCT activities in the service agreements",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="4.7"
          title="Implementation of the Procedure and/or Process for Service Agreements (including POCT)"
          questions={[
            {
              content:
                "Has the laboratory implemented a procedure and/or process and have records including but not limited to the following?",
              hideOptions: true,
            },
            {
              content:
                "Establishment of service agreements (requirements are specified);",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Review and approval of service agreements (capability and adequate resources);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Management of walk-in patients, (where applicable);",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication of changes of the service agreement that affect examination results;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication to the requester of any work that has been referred;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Definitions of specified responsibilities and authorities for POCT activities in the service agreements",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="4.8"
          title="Laboratory Information for Patients and Users"
          questions={[
            {
              content: (
                <>
                  Is laboratory information available for patients and
                  laboratory users in the language understood by the community?
                  <br />
                  Note 1: Laboratory information may be in the form of
                  Laboratory Handbook, brochure, videos, website, etc.
                  <br />
                  Note 2: The laboratory should provide its clients with a
                  handbook that outlines the laboratory hours of operation,
                  available tests, sample collection instructions, packaging,
                  and shipping directions, and expected turnaround times
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="4.9"
          title="Communication Policy on Delays in Service"
          questions={[
            {
              content: (
                <>
                  Is timely-documented notification provided to patients and
                  users when the laboratory experiences delays or interruptions
                  in testing (due to equipment failure, stock outs, personnel
                  levels, etc.) or finds it necessary to change examination
                  procedures and when testing resumes?
                  <br />
                  Note 1: There must be a policy for notifying patients or users
                  when the laboratory experiences delays or interruptions in
                  testing
                  <br />
                  Note 2: There must be records of communication. Communication
                  may be in the form of telephonic messages, memos, emails, etc.
                  There must be records of communication when an examination is
                  delayed to the requester and or clinical personnel
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="4.10"
          title="Utilization of Customer Feedback"
          questions={[
            {
              content: (
                <>
                  Are there opportunities for laboratory patients, users and
                  personnel to provide information to aid the laboratory in
                  improving its management system, laboratory activities, and
                  services to users?
                  <br />
                  Note 1: The laboratory should measure the satisfaction of
                  patients, users, and personnel regarding its services on an
                  ongoing basis
                  <br />
                  Note 2: There must be records of feedback including actions
                  taken.
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddCustomerFocus = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [status, setStatus] = useState(null);

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

  // --- Prefill answers if editing ---
  const {
        formData: answers,
        handleChange: handleAnswerChange,
        handleDone,
        editMode,
        loading,
        isFetching,
      } = useCertification(
        "Customer Focus", // section
        {},                    // initialAnswers
        questionnaireId        // questionnaireId (optional)
      );

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  return (
    <div
      className={`${classes.wrapper} ${!editMode ? classes.fromParams : ""}`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">
          Section 04: Customer Focus {questionnaireId && "(Editing)"}
        </h2>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(
            handleAnswerChange,
            answers,
            editMode
          )}

          {editMode && (
            <CommonFooter
              handlePrevious={handlePrevious}
              handleCancel={() => navigate(-1)}
              handleNext={handleNext}
              handleDone={handleDone}
              questionSets={questionSets}
              currentSet={currentSet}
              cancelText="Cancel"
              doneText={
                questionnaireId ? "Update Assessment" : "Submit Assessment"
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default AddCustomerFocus;
